var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _g310, _g311, _g312, _g313, _g314, _g315, _g316, _g317, _g318, _g319, _g320, _g321, _g322, _g323, _g324, _g325, _g326, _g327, _g328, _g329, _g330, _g331, _g332, _g333, _g334, _g335, _g336, _g337, _g338, _g339, _g340, _g341, _g342, _g343, _g344, _g345, _g346, _g347, _g348, _g349, _g350, _g351, _g352, _g353, _g354, _g355, _g356, _g357, _g358, _g359, _g360, _g361, _g362, _g363, _g364, _g365, _g366, _g367, _g368, _g369, _g370, _g371, _g372, _g373, _g374, _g375, _g376, _g377, _g378, _g379, _g380, _g381, _g382, _g383, _g384, _g385, _g386, _g387, _g388, _g389, _g390, _g391, _g392, _g393, _g394, _g395, _g396, _g397, _g398, _g399, _g400, _g401, _g402, _g403, _g404, _g405, _g406, _g407, _g408, _g409, _g410, _g411, _g412, _g413, _g414, _g415, _g416, _g417, _g418, _g419, _g420, _g421, _g422, _g423, _g424, _g425, _g426, _g427, _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "1295px",
    height: "1295px",
    viewBox: "0 0 1295 1295",
    enableBackground: "new 0 0 1295 1295",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1295,
    height: 1295,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g85 || (_g85 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g87 || (_g87 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g89 || (_g89 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g91 || (_g91 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g93 || (_g93 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g95 || (_g95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g97 || (_g97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g103 || (_g103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g105 || (_g105 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g106 || (_g106 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g107 || (_g107 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g108 || (_g108 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g109 || (_g109 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g117 || (_g117 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g118 || (_g118 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g121 || (_g121 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g123 || (_g123 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g126 || (_g126 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g127 || (_g127 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g128 || (_g128 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g129 || (_g129 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g130 || (_g130 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g132 || (_g132 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g133 || (_g133 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g134 || (_g134 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g135 || (_g135 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g136 || (_g136 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g137 || (_g137 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g138 || (_g138 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g139 || (_g139 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g140 || (_g140 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g141 || (_g141 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g142 || (_g142 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g143 || (_g143 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g144 || (_g144 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g145 || (_g145 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g146 || (_g146 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g147 || (_g147 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g148 || (_g148 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g149 || (_g149 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g150 || (_g150 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g151 || (_g151 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g152 || (_g152 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g153 || (_g153 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g154 || (_g154 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g155 || (_g155 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g156 || (_g156 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g157 || (_g157 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g158 || (_g158 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g159 || (_g159 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g160 || (_g160 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g161 || (_g161 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g162 || (_g162 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g163 || (_g163 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g164 || (_g164 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g165 || (_g165 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g166 || (_g166 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g167 || (_g167 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g168 || (_g168 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g169 || (_g169 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g170 || (_g170 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g171 || (_g171 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g172 || (_g172 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g173 || (_g173 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g174 || (_g174 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g175 || (_g175 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g176 || (_g176 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g177 || (_g177 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g178 || (_g178 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g179 || (_g179 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g180 || (_g180 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g181 || (_g181 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g182 || (_g182 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g183 || (_g183 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g184 || (_g184 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g185 || (_g185 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g186 || (_g186 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g187 || (_g187 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g188 || (_g188 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g189 || (_g189 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g190 || (_g190 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g191 || (_g191 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g192 || (_g192 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g193 || (_g193 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g194 || (_g194 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g195 || (_g195 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g196 || (_g196 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g197 || (_g197 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g198 || (_g198 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g199 || (_g199 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g200 || (_g200 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g201 || (_g201 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g202 || (_g202 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g203 || (_g203 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g204 || (_g204 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g205 || (_g205 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g206 || (_g206 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g207 || (_g207 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g208 || (_g208 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g209 || (_g209 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g210 || (_g210 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g211 || (_g211 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g212 || (_g212 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g213 || (_g213 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g214 || (_g214 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g215 || (_g215 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g216 || (_g216 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g217 || (_g217 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g218 || (_g218 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g219 || (_g219 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g220 || (_g220 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g221 || (_g221 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g222 || (_g222 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g223 || (_g223 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g224 || (_g224 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g225 || (_g225 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g226 || (_g226 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g227 || (_g227 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g228 || (_g228 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g229 || (_g229 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g230 || (_g230 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g231 || (_g231 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g232 || (_g232 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g233 || (_g233 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g234 || (_g234 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g235 || (_g235 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g236 || (_g236 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g237 || (_g237 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g238 || (_g238 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g239 || (_g239 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g240 || (_g240 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g241 || (_g241 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g242 || (_g242 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g243 || (_g243 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g244 || (_g244 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g245 || (_g245 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g246 || (_g246 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g247 || (_g247 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g248 || (_g248 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g249 || (_g249 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g250 || (_g250 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g251 || (_g251 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g252 || (_g252 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g253 || (_g253 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g254 || (_g254 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g255 || (_g255 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g256 || (_g256 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g257 || (_g257 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g258 || (_g258 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g259 || (_g259 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g260 || (_g260 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g261 || (_g261 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g262 || (_g262 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g263 || (_g263 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g264 || (_g264 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g265 || (_g265 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g266 || (_g266 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g267 || (_g267 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g268 || (_g268 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g269 || (_g269 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g270 || (_g270 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g271 || (_g271 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g272 || (_g272 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g273 || (_g273 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g274 || (_g274 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g275 || (_g275 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g276 || (_g276 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g277 || (_g277 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g278 || (_g278 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g279 || (_g279 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g280 || (_g280 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g281 || (_g281 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g282 || (_g282 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g283 || (_g283 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g284 || (_g284 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g285 || (_g285 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g286 || (_g286 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g287 || (_g287 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g288 || (_g288 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g289 || (_g289 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g290 || (_g290 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g291 || (_g291 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g292 || (_g292 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g293 || (_g293 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g294 || (_g294 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g295 || (_g295 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g296 || (_g296 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g297 || (_g297 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g298 || (_g298 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g299 || (_g299 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g300 || (_g300 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g301 || (_g301 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g302 || (_g302 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g303 || (_g303 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g304 || (_g304 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g305 || (_g305 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g306 || (_g306 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g307 || (_g307 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g308 || (_g308 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g309 || (_g309 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g310 || (_g310 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g311 || (_g311 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g312 || (_g312 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g313 || (_g313 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g314 || (_g314 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g315 || (_g315 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g316 || (_g316 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g317 || (_g317 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g318 || (_g318 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g319 || (_g319 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g320 || (_g320 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g321 || (_g321 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g322 || (_g322 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g323 || (_g323 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g324 || (_g324 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g325 || (_g325 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g326 || (_g326 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g327 || (_g327 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g328 || (_g328 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g329 || (_g329 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g330 || (_g330 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g331 || (_g331 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g332 || (_g332 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g333 || (_g333 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g334 || (_g334 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g335 || (_g335 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g336 || (_g336 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g337 || (_g337 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g338 || (_g338 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g339 || (_g339 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g340 || (_g340 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g341 || (_g341 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g342 || (_g342 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g343 || (_g343 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g344 || (_g344 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g345 || (_g345 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g346 || (_g346 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g347 || (_g347 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g348 || (_g348 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g349 || (_g349 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g350 || (_g350 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g351 || (_g351 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g352 || (_g352 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g353 || (_g353 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g354 || (_g354 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g355 || (_g355 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g356 || (_g356 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g357 || (_g357 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g358 || (_g358 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g359 || (_g359 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g360 || (_g360 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g361 || (_g361 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g362 || (_g362 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g363 || (_g363 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g364 || (_g364 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g365 || (_g365 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g366 || (_g366 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g367 || (_g367 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g368 || (_g368 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g369 || (_g369 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g370 || (_g370 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g371 || (_g371 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g372 || (_g372 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g373 || (_g373 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g374 || (_g374 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g375 || (_g375 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g376 || (_g376 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g377 || (_g377 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g378 || (_g378 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g379 || (_g379 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g380 || (_g380 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g381 || (_g381 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g382 || (_g382 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g383 || (_g383 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g384 || (_g384 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g385 || (_g385 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g386 || (_g386 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g387 || (_g387 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g388 || (_g388 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g389 || (_g389 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g390 || (_g390 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g391 || (_g391 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,1015) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g392 || (_g392 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g393 || (_g393 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g394 || (_g394 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g395 || (_g395 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g396 || (_g396 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g397 || (_g397 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g398 || (_g398 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g399 || (_g399 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g400 || (_g400 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g401 || (_g401 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,1050) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g402 || (_g402 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g403 || (_g403 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g404 || (_g404 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g405 || (_g405 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g406 || (_g406 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g407 || (_g407 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g408 || (_g408 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g409 || (_g409 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g410 || (_g410 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g411 || (_g411 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g412 || (_g412 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1050,1085) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g413 || (_g413 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g414 || (_g414 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g415 || (_g415 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g416 || (_g416 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g417 || (_g417 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g418 || (_g418 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g419 || (_g419 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g420 || (_g420 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g421 || (_g421 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g422 || (_g422 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g423 || (_g423 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g424 || (_g424 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g425 || (_g425 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g426 || (_g426 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085,1120) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _g427 || (_g427 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(2.4019607843137, 2.4019607843137)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M51,16c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S70.299,16,51,16z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51,1C23.387,1,1,23.387,1,51s22.387,50,50,50s50-22.387,50-50S78.613,1,51,1z M51,86c-19.299,0-35-15.701-35-35 s15.701-35,35-35s35,15.701,35,35S70.299,86,51,86z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,0) scale(2.4019607843137, 2.4019607843137)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M51,16c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S70.299,16,51,16z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51,1C23.387,1,1,23.387,1,51s22.387,50,50,50s50-22.387,50-50S78.613,1,51,1z M51,86c-19.299,0-35-15.701-35-35 s15.701-35,35-35s35,15.701,35,35S70.299,86,51,86z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,910) scale(2.4019607843137, 2.4019607843137)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M51,16c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S70.299,16,51,16z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51,1C23.387,1,1,23.387,1,51s22.387,50,50,50s50-22.387,50-50S78.613,1,51,1z M51,86c-19.299,0-35-15.701-35-35 s15.701-35,35-35s35,15.701,35,35S70.299,86,51,86z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,70) scale(1.0294117647059, 1.0294117647059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,70) scale(1.0294117647059, 1.0294117647059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,980) scale(1.0294117647059, 1.0294117647059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "#cf7d36"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.7fda00a8d5dcde1a49320b3965fde009.svg";
export { ForwardRef as ReactComponent };